export const tableColumns = {
  EmpName: 'Employee Name',
  Designation: 'Designation',
  ModifiedDate: 'Date',
  CurrentStage: 'Current Status',
  Feedback_Date: 'Due Date',
  Overall_Rating_Manager: 'Overall Manager Rating',
  Overall_Rating_Calibration: 'Overall Calibration Rating',
};
